import { render, staticRenderFns } from "./addQuestion.vue?vue&type=template&id=d536b7f8&scoped=true&"
import script from "./addQuestion.vue?vue&type=script&lang=js&"
export * from "./addQuestion.vue?vue&type=script&lang=js&"
import style0 from "./addQuestion.vue?vue&type=style&index=0&id=d536b7f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d536b7f8",
  null
  
)

export default component.exports